export default __webpack_public_path__ + "static/media/IraLippkeStudios_Lina_Shteyn_BarDivEng-049.dbfb7d5b.jpg";